
import { Component, Mixins } from 'vue-property-decorator'
import ExitModalMixin from './ExitModalMixin'
import CSSCheckIcon from '~/components/common/CSSCheckIcon.vue'
import Package from '~/components/common/modals/payment/Package.vue'
import PaymentForm from '~/components/common/modals/payment/PaymentForm.vue'
import PaymentFormStripe from '~/components/common/modals/payment/PaymentFormStripe.vue'
import mixpanelEventValues from '~/plugins/mixpanel/values'

declare global {
  interface Window {
    braintree: any;
    dataLayer: any;
    ga: any;
    Stripe: any;
  }
}

@Component({
  components: {
    Package,
    CSSCheckIcon,
    PaymentForm,
    PaymentFormStripe
  }
})
export default class PaymentModal extends Mixins(ExitModalMixin) {
  campaignName = 'ScholarshipOwl No Essay'
  campaignAmount = '$50,000'

  redirectToUrl = ''

  continueWithFreemiumLink: HTMLElement = null

  created() {
    this.$accessor.payment.getToken()
  }

  mounted() {
    const props = this.$mixpanel.fillProps(this.$mixpanel.events.PAYMENT_MODAL_OPEN)
    this.$mixpanel.track(this.$mixpanel.events.PAYMENT_MODAL_OPEN, props)
    this.googleAnalyticTrack()

    this.continueWithFreemiumLink = document.getElementById('continueWithFreemium')
    if (!this.continueWithFreemiumLink) { return }
    if (!this.pd.convertToFreemiumEnabled) {
      this.continueWithFreemiumLink?.replaceWith('!')
    }
    this.continueWithFreemiumLink?.addEventListener(
      'click',
      this.continueWithFreemiumLinkClickHandler
    )
  }

  beforeDestroy() {
    this.continueWithFreemiumLink?.removeEventListener(
      'click',
      this.continueWithFreemiumLinkClickHandler
    )
  }

  get paymentMethod() {
    return this.$accessor.account.paymentMethod
  }

  get paymentFormByMethod() {
    return (paymentMethod) => {
      // return PaymentForm
      if (paymentMethod === 'Stripe') { return PaymentFormStripe }
      if (paymentMethod === 'Braintree') { return PaymentForm }
      return ''
    }
  }

  get pd() {
    return this.$accessor.account.paymentDetails
  }

  get packageDescription() {
    if (Number(this.sp.discountPrice) !== 0) { return `$${this.sp.discountPrice} for your first month, then only $${this.sp.pricePerMonth} per month. ${this.sp.name}` }
    if (this.sp.isFreeTrial) { return `${this.sp.freeTrialPeriodText} free, then only $${this.sp.pricePerMonth} per month. ${this.sp.name}` }
    if (this.sp.expirationType === 'recurrent' && this.sp.pricePerMonth) { return `${this.sp.name.toUpperCase()} membership for $${this.sp.pricePerMonth} per month` }
    return `${this.sp.name.toUpperCase()} package for $${this.sp.price}`
  }

  sp = null

  close() {
    const paymentModalCloseEvent = this.$mixpanel.events.PAYMENT_MODAL_CLOSE
    const paymentModalCloseEventProps = this.$mixpanel.fillProps(paymentModalCloseEvent)
    this.$mixpanel.track(paymentModalCloseEvent, paymentModalCloseEventProps)
    this.$emit('close')

    if (!this.isExitPopupAllowed) { return }

    this.showExitModal()
  }

  googleAnalyticTrack() {
    if (window.ga?.create) {
      window.ga('send', 'event', 'payment', 'popupLoaded', { page: this.$route.fullPath })
    }
  }

  setPackage(pack) {
    this.$mixpanel.track(
      this.$mixpanel.events.PACKAGE_BUTTON_CLICK,
      {
        [this.$mixpanel.props.PAYMENT_PACKAGE_ID]: pack.packageId,
        [this.$mixpanel.props.PAYMENT_PACKAGE_NAME]: pack.name,
        [this.$mixpanel.props.PAYMENT_PACKAGE_PRICE]: pack.price,
        [this.$mixpanel.props.PRO_MODAL_NEW]: mixpanelEventValues[this.$mixpanel.props.PRO_MODAL_NEW]()
      }
    )

    this.sp = pack
  }

  removePackage() {
    this.sp = null
  }

  isContinueWithFreemiumLoading = false
  isContinueWithFreemiumFailed = false

  continueWithFreemiumLinkClickHandler(event: MouseEvent) {
    event.preventDefault()
    this.$accessor.account.continueWithFreemium()
    this.$mixpanel.track(this.$mixpanel.events.CONTINUE_WITH_FREEMIUM_BUTTON_CLICK)
  }
}
